{
  "conversations": {
    "conversationsApp": "Aplicação de conversas",
    "locationId": "ID da localização",
    "idToken": "Token de ID",
    "conversationRoutes": "Rotas de conversas",
    "conversationProviders": "Fornecedores de Conversação",
    "viewTheListOfConversation": "Ver a Lista de fornecedores Personalizado de conversa adicionados à Conta aqui.",
    "logo": "Logótipo",
    "name": "Nome",
    "alias": "Alias",
    "type": "Tipo"
  }
}
